// extracted by mini-css-extract-plugin
export default {"item-wrapper":"LiveTVCollectionItem_item-wrapper__IRjNx"};